import { format, getTime, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy';

  return date ? format(new Date(date), fm) : '';
}

export function fDateTime(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy p';

  return date ? format(new Date(date), fm) : '';
}

export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}

export function formatDateToLocal(isoString) {
  return format(new Date(isoString), 'yyyy-MM-dd');
}
export function formatDateToLocal2(isoString) {
  return format(new Date(isoString), 'd MMMM yyyy');
}


export const formatApiDateTime=(inputDate)=>{

const dateParts = inputDate.split(" at ");
const [day, month, year] = dateParts[0].split(" ");
const time = dateParts[1];

const date = new Date(`${month} ${day}, ${year} ${time}:00`);

const options = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true
};

const formattedDate = date.toLocaleString('en-US', options).replace(',', '').replace(' at', ' at');

return formattedDate

}
export function formatPrice(price) {
  if (isNaN(price)) {
    return 'Invalid price';
  }

  price = parseFloat(price);

  return price.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}



export function convertTimeToEST(dateInput) {
  const date = new Date(dateInput);

  return date.toLocaleString('en-US', {
    timeZone: 'America/New_York',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
}


export function convertDateToEST(dateInput) {
  const date = new Date(dateInput);

  return date.toLocaleString('en-US', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour12: true,
  });
}